/*
  WhatsApp click tracking.
  Fires on any element carrying [data-wa-link] (inline links AND the floating button).

  Emits two things so nothing is lost before GTM/GA4 exist:
    1. window.dataLayer push  -> picked up automatically once GTM is installed
    2. 'wa_click' DOM event   -> for any other listener (server-side bridge, Pixel, etc.)

  No dependencies. Safe to load before or without GTM.
*/
(function () {
  window.dataLayer = window.dataLayer || [];

  function payload(el) {
    return {
      event: 'wa_click',
      wa_source: el.getAttribute('data-wa-source') || 'unknown',
      wa_context: el.getAttribute('data-wa-context') || '',
      page_type: (document.body && document.body.getAttribute('data-template')) || '',
      page_path: window.location.pathname
    };
  }

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-wa-link]') : null;
    if (!el) return;
    var data = payload(el);
    try { window.dataLayer.push(data); } catch (err) {}
    try {
      document.dispatchEvent(new CustomEvent('wa_click', { detail: data }));
    } catch (err) {}
    // Shopify analytics bus -> reaches Custom Pixels (sandboxed, can't hear DOM events)
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('wa_click', data);
      }
    } catch (err) {}
  }, true);
})();
